export function WKnightIcon({ color = "#3C3C3C" }: { color?: string }) {
  return (
    <svg
      height="1em"
      viewBox="0 0 131 153"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M75.2138 67.9858C74.5885 94.3185 30.7741 87.7108 31.6888 136.41L118.089 136.858C110.174 112.51 154.712 41.765 72.9952 14.9379C72.9952 14.9379 63.7804 5.10696 50.4485 4.26526L51.2902 17.6248L34.062 34.941C24.1241 46.8295 1.04891 66.6074 4.7657 71.2664C16.542 91.3134 28.6924 88.0158 28.6924 88.0158C44.7244 70.8443 50.6858 80.1192 75.2138 67.9858Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="8"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M74.4882 118.79C74.4882 118.79 39.9777 118.972 30.3017 124.91C23.7733 128.917 22.2332 138.711 23.1214 148.811H125.857C126.745 138.711 125.205 128.917 118.676 124.91C109.001 118.972 74.4882 118.79 74.4882 118.79Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="8"
        stroke-linejoin="round"
      />
    </svg>
  );
}
